import * as React from 'react';
import {ApolloProvider} from 'react-apollo';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {Router} from 'react-router-dom';

import {ApolloProvider as ReactHooksApolloProvider} from '@apollo/react-hooks';

import {nutApolloClient} from '../../../../apollo-client';
import {appHistory} from '../../../../history';
import {store} from '../../../../store';

import {ManageAllRolesPermissionsTable} from './manage-all-roles-permissions-table';
import {ManageRolePermissionsTable} from './manage-role-permissions-table';

const MANAGE_ALL_ROLES_PERMISSIONS_REACT_MOUNT_ID = 'manage-all-roles-permissions-react-mount';
const MANAGE_ROLE_PERMISSIONS_REACT_MOUNT_ID = 'manage-role-permissions-react-mount';

export function mountRolesAndPermissionsTables() {
    const manageAllRolesAndPermissionsMount = document.getElementById(
        MANAGE_ALL_ROLES_PERMISSIONS_REACT_MOUNT_ID
    );
    const manageRolePermissionsMount = document.getElementById(
        MANAGE_ROLE_PERMISSIONS_REACT_MOUNT_ID
    );

    let reactMount, reactComponent;
    if (manageAllRolesAndPermissionsMount) {
        reactMount = manageAllRolesAndPermissionsMount;
        reactComponent = <ManageAllRolesPermissionsTable />;
    } else if (manageRolePermissionsMount) {
        reactMount = manageRolePermissionsMount;
        reactComponent = <ManageRolePermissionsTable />;
    }

    if (reactMount) {
        ReactDOM.render(
            <Provider store={store}>
                <ApolloProvider client={nutApolloClient}>
                    <ReactHooksApolloProvider client={nutApolloClient}>
                        <Router history={appHistory}>{reactComponent}</Router>
                    </ReactHooksApolloProvider>
                </ApolloProvider>
            </Provider>,
            reactMount
        );
    }
}
